import {
  CheckmarkIcon,
  DownloadIcon,
  XmarkIcon,
  CaretIcon,
  InfoIcon,
  ExternalLinkIcon,
} from "components/page-components/Icons/small"
import { graphql, useStaticQuery } from "gatsby"

import { GatsbyImage } from "gatsby-plugin-image"
import { NoticePageCTANotification } from "components/noticepage_components/utils"
import React, { useState } from "react"
import createStandardGermanDateWithTime from "scripts/createStandardGermanDateWithTime"

export const NoticeDownloads = ({
  application_required,
  documents,
  failed_request,
  info_notification_open,
  pq_accepted,
  proofs,
  set_download_update_info_modal_open,
  fetch_zip_modal_open,
  set_fetch_zip_modal_open,
  set_info_notification_open,
  zip_download = {},
  has_parts = false,
  vu_urls,
  RefIDStringBI,
}) => {
  const hand_ins = []
  const default_hand_ins_sorting = [12, 14, 13]

  const acknowledgements = []
  const tender_info = []
  const todo_mapping = {
    10: acknowledgements,
    11: tender_info,
    12: hand_ins,
    13: hand_ins,
    14: hand_ins,
  }

  if (documents) {
    documents?.map((doc) =>
      todo_mapping[doc.todo].push({
        ...doc,
        createdOn: createStandardGermanDateWithTime(doc.createdOn),
        created_timestamp: new Date(doc.createdOn).valueOf(),
        tag: null,
      })
    )
  }

  const [sort_hand_ins_by, set_sort_hand_ins_by] = useState({
    attribute: "todo",
    order: "default",
  })
  const toggle_todo_sorting = () =>
    set_sort_hand_ins_by({
      attribute: "todo",
      order:
        typeof sort_hand_ins_by.order === "boolean"
          ? !sort_hand_ins_by.order
          : false,
    })
  const toggle_createdOn_sorting = () =>
    set_sort_hand_ins_by({
      attribute: "created_timestamp",
      order: !!sort_hand_ins_by.order ? false : !sort_hand_ins_by.order,
    })

  const sorted_hand_ins = [...hand_ins].sort((a, b) =>
    sort_hand_ins_by.order === "default"
      ? default_hand_ins_sorting.indexOf(a.todo) -
        default_hand_ins_sorting.indexOf(b.todo)
      : sort_hand_ins_by.order
        ? a[sort_hand_ins_by.attribute] - b[sort_hand_ins_by.attribute]
        : b[sort_hand_ins_by.attribute] - a[sort_hand_ins_by.attribute]
  )

  const tag_colors = {
    neu: "success",
    bearbeitet: "mitternachtsblau",
    gelöscht: "danger",
  }

  const [download_click, set_download_click] = useState(null)

  const { zip_url } = zip_download

  const blur_download_link = async () => {
    if (!fetch_zip_modal_open) {
      return
    }
    const download_start = performance.now()
    const download_delay = download_click - download_start
    await new Promise((resolve) =>
      setTimeout(
        () => {
          resolve(null)
        },
        Math.max(5000 - download_delay, 10)
      )
    )
    set_fetch_zip_modal_open(false)
  }

  const download_zip_file = () => {
    set_download_click(performance.now())
    set_fetch_zip_modal_open(true)
  }
  const { searchingImage } = useStaticQuery(graphql`
    {
      searchingImage: file(name: { eq: "looking-for-tenders" }) {
        childImageSharp {
          gatsbyImageData(
            layout: CONSTRAINED
            placeholder: BLURRED
            width: 290
            formats: [AVIF, AUTO]
          )
        }
      }
    }
  `)

  return (
    <React.Fragment>
      {failed_request ? (
        <div className="is-flex is-flex-direction-column">
          <p className="title is-5 mt-6 pt-6 has-text-centered has-text-mitternachtsblau">
            Tut uns Leid, wir konnten die Unterlagen nicht finden.
          </p>
          <p className="mb-6 has-text-centered has-text-mitternachtsblau">
            Es ist ein Fehler aufgetreten, das tut uns leid.
          </p>
        </div>
      ) : (
        <React.Fragment>
          {!!vu_urls ? (
            <React.Fragment>
              <div className="box mx-3">
                <p className="title is-4 has-text-mitternachtsblau">
                  Unterlagen auf externer Plattform
                </p>
                <hr className="is-evergabe is-slim" />
                <table className="table is-fullwidth is-striped">
                  <tbody>
                    {vu_urls.map((vu_url, index) => {
                      return (
                        <tr key={vu_url + index + "url"}>
                          <td>
                            <ExternalLinkIcon />
                          </td>
                          <td>
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={vu_url}
                              className="link is-shy"
                            >
                              {vu_url}
                            </a>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
              <div className="box mx-3 has-background-mitternachtsblau is-flex is-flex-direction-row">
                <div className="my-auto">
                  <InfoIcon {...{ color: "#FFFFFF" }} />
                </div>
                <div className="my-auto ml-4">
                  <p className="has-text-white">
                    Diese Vergabe wird über eine externe Plattform (nicht B_I
                    MEDIEN) abgewickelt.
                  </p>
                </div>
              </div>
            </React.Fragment>
          ) : !!documents ? (
            <React.Fragment>
              {info_notification_open ? (
                <NoticePageCTANotification
                  {...{
                    set_download_update_info_modal_open,
                    current_part: "downloads",
                    set_info_notification_open,
                    application_required,
                    RefIDStringBI,
                  }}
                />
              ) : null}

              <div className="p-3">
                {!!sorted_hand_ins?.[0] ||
                !!acknowledgements?.[0] ||
                !!tender_info?.[0] ? (
                  <div className="is-flex mb-5">
                    <a
                      href={zip_url}
                      download
                      onClick={download_zip_file}
                      className="link is-flex ml-auto"
                      onBlur={blur_download_link}
                    >
                      <span className="mr-2">Alle herunterladen</span>
                      <span className="icon">
                        <DownloadIcon />
                      </span>
                    </a>
                  </div>
                ) : (
                  <div className="is-flex p-6">
                    <div className="m-auto has-text-centered">
                      <GatsbyImage
                        image={searchingImage.childImageSharp.gatsbyImageData}
                        alt="Keine Unterlagen gefunden"
                        title="Keine Unterlagen gefunden"
                      />
                      <p className="has-text-centered has-text-mitternachtsblau py-5">
                        Zu {has_parts ? "diesem Los" : "dieser Vergabe"} gibt es
                        noch keine Unterlagen.
                      </p>
                    </div>
                  </div>
                )}
                {!!sorted_hand_ins?.[0] ? (
                  <div className="box">
                    <p className="title is-4 has-text-mitternachtsblau">
                      Einzureichende Unterlagen
                    </p>
                    <div className="table-container no-scrollbar">
                      <table className="table is-fullwidth">
                        <thead>
                          <tr>
                            <th
                              className="has-text-evergabe title is-7 px-0"
                              style={{ minWidth: 280 }}
                            >
                              Unterlagenbezeichnung
                            </th>
                            <th
                              className="px-0 is-clickable"
                              onClick={toggle_todo_sorting}
                            >
                              Abgabe mit
                              <span className="ml-2">
                                <CaretIcon
                                  {...{
                                    size: 0.8,
                                    color:
                                      sort_hand_ins_by.attribute === "todo"
                                        ? "#034055"
                                        : "#7aa0ad",
                                    rotation:
                                      sort_hand_ins_by.attribute === "todo" &&
                                      sort_hand_ins_by.order
                                        ? "up"
                                        : "down",
                                  }}
                                />
                              </span>
                            </th>
                            <th
                              className="pl-0 pr-6 is-narrow is-clickable"
                              onClick={toggle_createdOn_sorting}
                            >
                              Letzte Änderung
                              <span className="ml-2">
                                <CaretIcon
                                  {...{
                                    size: 0.8,
                                    color:
                                      sort_hand_ins_by.attribute ===
                                      "created_timestamp"
                                        ? "#034055"
                                        : "#7aa0ad",
                                    rotation:
                                      sort_hand_ins_by.attribute ===
                                        "created_timestamp" &&
                                      sort_hand_ins_by.order
                                        ? "up"
                                        : "down",
                                  }}
                                />
                              </span>
                            </th>
                            <td
                              aria-label="table-field"
                              className="is-narrow"
                            ></td>
                          </tr>
                        </thead>
                        <tbody>
                          {sorted_hand_ins?.map(
                            (
                              {
                                createdOn,
                                description,
                                link,
                                originalFilename,
                                tag,
                                todo,
                              },
                              i
                            ) => {
                              return (
                                <tr key={"hand_in-" + i}>
                                  <td className="has-text-mitternachtsblau px-0 py-4 ">
                                    <a href={link} className="link is-semi-shy">
                                      {description}
                                    </a>
                                    <p className="help">{originalFilename}</p>
                                  </td>
                                  <td
                                    className={`has-text-mitternachtsblau py-4 pl-0`}
                                  >
                                    {todo === 14
                                      ? "Teilnahmeantrag"
                                      : "Angebot"}
                                    {todo === 13 ? (
                                      <p className="help has-text-mitternachtsblau">
                                        nur nach Aufforderung
                                      </p>
                                    ) : null}
                                  </td>
                                  <td className="has-text-mitternachtsblau py-4 pl-0 pr-6 is-narrow">
                                    <p>{createdOn}</p>

                                    {!!tag ? (
                                      <div
                                        className={`tag mt-3 px-4 is-${tag_colors[tag]}`}
                                      >
                                        {tag}
                                      </div>
                                    ) : null}
                                  </td>
                                  <td className="is-narrow pr-0 py-4">
                                    <a href={link} className="link is-flex">
                                      <span className="mr-2">
                                        Datei herunterladen
                                      </span>
                                      <span className="icon">
                                        <DownloadIcon />
                                      </span>
                                    </a>
                                  </td>
                                </tr>
                              )
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : null}
                {!!proofs?.[0] ? (
                  <React.Fragment>
                    <div className="box mt-6">
                      <p className="title is-4 has-text-mitternachtsblau">
                        Nachweise, die Sie erbringen müssen
                      </p>
                      <div className="table-container no-scrollbar">
                        <table className="table is-fullwidth">
                          <thead>
                            <tr>
                              <th className="px-0" style={{ minWidth: 280 }}>
                                Unterlagenbezeichnung
                              </th>
                              <th className="is-narrow pr-0">
                                Eigenerklärung zulässig
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {proofs?.map(
                              (
                                { name, description, isSelfDeclarationAllowed },
                                i
                              ) => {
                                return (
                                  <tr key={"download_metadata-" + i}>
                                    <td className="has-text-mitternachtsblau px-0 py-4">
                                      <p className="">{name}</p>
                                      <p className="help">{description}</p>
                                    </td>

                                    <td className="is-narrow pr-0 has-text-right has-text-mitternachtsblau py-4">
                                      {isSelfDeclarationAllowed ? "Ja" : "Nein"}
                                    </td>
                                  </tr>
                                )
                              }
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="box is-bordered has-background-mitternachtsblau-5">
                      <p className="is-flex has-text-mitternachtsblau">
                        <span className="icon mr-4">
                          {pq_accepted ? (
                            <CheckmarkIcon
                              {...{
                                color: "#0EAA2D",
                                size: 0.6,
                                strokeWidth: "5",
                              }}
                            />
                          ) : (
                            <XmarkIcon
                              {...{
                                color: "#E70023",
                                size: 0.5,
                                strokeWidth: "6",
                              }}
                            />
                          )}
                        </span>
                        <span>
                          Nachweise können {pq_accepted ? "" : <b>nicht</b>} per
                          Präqualifikation erbracht werden.
                          {pq_accepted ? (
                            <span className="help has-text-mitternachtsblau">
                              Bitte weisen Sie Ihre Präqualifizierung durch
                              Angabe Ihrer PQ-Nr. nach, zum Beispiel durch einen
                              Eintrag im Angebotsschreiben.
                            </span>
                          ) : null}
                        </span>
                      </p>
                    </div>
                  </React.Fragment>
                ) : null}

                {!!acknowledgements?.[0] ? (
                  <div className="box mt-6">
                    <p className="title is-4 has-text-mitternachtsblau">
                      Unterlagen zur Kenntnisname
                    </p>
                    <div className="table-container no-scrollbar">
                      <table className="table is-fullwidth">
                        <thead>
                          <tr>
                            <th className="px-0" style={{ minWidth: 280 }}>
                              Unterlagenbezeichnung
                            </th>
                            <th className="px-0">Letzte Änderung</th>
                            <td aria-label="table-field"></td>
                          </tr>
                        </thead>
                        <tbody>
                          {acknowledgements?.map(
                            (
                              {
                                originalFilename,
                                link,
                                createdOn,
                                tag,
                                description,
                              },
                              i
                            ) => {
                              return (
                                <tr key={"acknowledgement-" + i}>
                                  <td className="has-text-mitternachtsblau px-0 py-4">
                                    <a href={link} className="link is-semi-shy">
                                      {description}
                                    </a>
                                    <p className="help">{originalFilename}</p>
                                  </td>

                                  <td className="has-text-mitternachtsblau py-4 pl-0 pr-6 is-narrow">
                                    <p>{createdOn}</p>
                                    {!!tag ? (
                                      <div
                                        className={`tag mt-3 px-4 is-${tag_colors[tag]}`}
                                      >
                                        {tag}
                                      </div>
                                    ) : null}
                                  </td>
                                  <td className="is-narrow pr-0 py-4">
                                    <a href={link} className="link is-flex">
                                      <span className="mr-2">
                                        Datei herunterladen
                                      </span>
                                      <span className="icon">
                                        <DownloadIcon />
                                      </span>
                                    </a>
                                  </td>
                                </tr>
                              )
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : null}
                {!!tender_info?.[0] ? (
                  <div className="box mt-6">
                    <p className="title is-4 has-text-mitternachtsblau mb-3">
                      Vertragsbestandteile, die beim Auftragnehmer verbleiben
                    </p>
                    <p className="has-text-mitternachtsblau mb-4">
                      Falls Sie den Zuschlag erhalten, werden folgende
                      Unterlagen zum Teil des Vertrags, den Sie mit dem
                      Auftraggeber schließen.
                    </p>
                    <div className="table-container no-scrollbar">
                      <table className="table is-fullwidth">
                        <thead>
                          <tr>
                            <th className="px-0" style={{ minWidth: 280 }}>
                              Unterlagenbezeichnung
                            </th>
                            <th className="px-0">Letzte Änderung</th>
                            <td aria-label="table-field"></td>
                          </tr>
                        </thead>
                        <tbody>
                          {tender_info?.map(
                            (
                              {
                                originalFilename,
                                link,
                                createdOn,
                                tag,
                                description,
                              },
                              i
                            ) => {
                              return (
                                <tr key={"tender_info-" + i}>
                                  <td className="has-text-mitternachtsblau px-0 py-4">
                                    <a href={link} className="link is-semi-shy">
                                      {description}
                                    </a>
                                    <p className="help">{originalFilename}</p>
                                  </td>

                                  <td className="has-text-mitternachtsblau py-4 pl-0 pr-6 is-narrow">
                                    <p>{createdOn}</p>
                                    {!!tag ? (
                                      <div
                                        className={`tag mt-3 px-4 is-${tag_colors[tag]}`}
                                      >
                                        {tag}
                                      </div>
                                    ) : null}
                                  </td>
                                  <td className="is-narrow pr-0 py-4">
                                    <a href={link} className="link is-flex">
                                      <span className="mr-2">
                                        Datei herunterladen
                                      </span>
                                      <span className="icon">
                                        <DownloadIcon />
                                      </span>
                                    </a>
                                  </td>
                                </tr>
                              )
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : null}
              </div>
            </React.Fragment>
          ) : (
            <div className="is-flex is-flex-direction-column">
              <p className="title is-5 my-6 has-text-centered has-text-mitternachtsblau">
                Unterlagen werden geladen, einen Moment bitte...
              </p>
              <div className="spinner m-auto"></div>
            </div>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  )
}
